import React from 'react';
import styled from 'react-emotion';

import BaseListItem from '@material-ui/core/ListItem';
import BaseListItemText from '@material-ui/core/ListItemText';
import BaseListItemAvatar from '@material-ui/core/ListItemAvatar';
import theme, { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const ListItem = styled(BaseListItem)`
  display: flex;
  align-items: center;
  padding: ${(props) =>
    props.size === 'small' ? '0' : `${theme.spacing.small} 0`};
  margin-top: ${(props) =>
    props.size === 'small' ? theme.spacing.small : '0'};

  &:hover {
    background-color: ${colors.designSystem.background.grey.hover};
  }
`;

export const ListItemText = styled(({ isAddAction, ...props }) => (
  <BaseListItemText
    {...props}
    classes={{ primary: 'primary', secondary: 'secondary' }}
  />
))`
  padding-left: ${theme.spacing.small};
  .primary {
    color: ${(props) =>
      props.isAddAction ? colors.black : colors.designSystem.marker};
    font-family: ${theme.font.family.workSans};
    font-weight: normal;
    font-size: ${theme.font.size.copy};
    line-height: ${theme.font.lineHeight.copy};
  }
`;

export const ListItemAvatar = styled(BaseListItemAvatar)`
  margin: 0;
`;
